import store from '@/store'

export default function requireAuth ({next, to}) {
  if (!store.getters.sessionIsAlive) {
    const getPath = to.fullPath
    const id = getPath.includes('solicitud') &&
      getPath.replace('/solicitud/mx/', '')
    if (id) {
      sessionStorage.setItem('sofom_back_to_fr', true)
      sessionStorage.setItem('sofom_fr_id', id)
    }
    next({ path: '/login', query: { redirect: to.fullPath } })
  }
  return next()
}



// WEBPACK FOOTER //
// ./src/middleware/requireAuth.js